module.exports = __webpack_public_path__ + "img/dsci0039.1b0184cf.jpg";